export const columns = [
  {
    title: "Details",
    fields: [
      "contact_name",
      "account_name",
      "title",
      "contact_group",
      "specialty_area",
      "role_category",
      "segment",
      "seniority_level",
      "accounts_type_name",
      "reports_to",
      "personal_strength"],
  },
  {
    title: "Geography And Interests",
    fields: [
      "region",
      "subsidiary",
      "city",
      "us_district",
      "area_of_interest",
      "industry_of_focus",
      "description",
      "tags",
    ],
  },
]
